import { z } from "zod";

export const customFieldInput = z.object({
  module: z.enum(["contacts", "products", "service_orders"]),
  label: z.string().trim().min(1).max(60),
  fieldType: z.enum(["text", "number", "decimal", "date", "boolean", "select", "multiselect", "url"]),
  options: z.array(z.string().trim().min(1).max(60)).max(50).optional(),
  required: z.boolean().default(false),
  position: z.number().int().min(0).max(999).default(0),
  active: z.boolean().default(true),
});
export type CustomFieldInput = z.output<typeof customFieldInput>;
export type CustomFieldRow = CustomFieldInput & { id: string };
